import { findSize } from './clean-department-utils'
import _ from 'lodash'

export function cleanFractions (department) {
  const size = findSize(department)

  const availableOptions = _.get(size, 'options', []).map(next => next.id)

  const sizesExcluded = _.get(department, 'fractions.sizesExcluded')

  if (sizesExcluded) {
    department.fractions.sizesExcluded = sizesExcluded.filter(next => availableOptions.includes(next.id))
  }
}
